import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import LeiService from '../../../../services/leis';
import { Link } from 'react-router-dom';
import Exportar from '../../../shared/export'



const FormBusca = (props) => {
    const [palavra, setPalavra] = useState("");
    const [numero, setNumero] = useState("");
    const [ano, setAno] = useState("");
    const [categoria, setCategoria] = useState("");



    const busca = async (query) => {
        if (query === "") {
            props.setAindaTem(true)
            await props.fetchLeisIn()
            setAno("")
            setNumero("")
            setPalavra("")
        } else {
            var response = await LeiService.buscar(query)
            if (response.data.length >= 1) {
                props.setLeis(response.data)
                props.setAindaTem(false)
                props.setVazio(false)
                setAno("")
                setNumero("")
                setPalavra("")
            } else {
                props.setVazio(true)
                setAno("")
                setNumero("")
                setPalavra("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (categoria !== "false" && categoria !== "") prepQuery = prepQuery + `categoria=${encodeURI(categoria)}`;
        if (numero) prepQuery = prepQuery + `&numero=${numero}`;
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Palavra">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Número">
                                <FloatingLabel
                                    label="Número da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Lei Municipal">Lei Municipal</option>
                                        <option value="Lei Tributária">Lei Tributária</option>
                                        <option value="Lei Orçamentária">Lei Orçamentária</option>
                                        <option value="Lei de Transparência">Lei de Transparência</option>
                                        <option value="Lei Orçamentária Anual - LOA">Lei Orçamentária Anual - LOA</option>
                                        <option value="Lei Orçamentária Plurianual - PPA">Lei Orçamentária Plurianual - PPA</option>
                                        <option value="Lei de Diretrizes Orçamentárias - LDO">Lei de Diretrizes Orçamentárias - LDO</option>
                                        <option value="Decreto">Decretos</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Lei Orgânica">Lei Orgânica</option>
                                        <option value="Lei de Vigilância Sanitária">Lei de Vigilância Sanitária</option>
                                        <option value="Índice">Índices</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
                <Row xs={1}>
                    <Col xs={12}>
                        <Exportar data={props.leis} nome={"Leis"} />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default FormBusca